<template>
  <div id="punchClockRecords" v-if="isOpenId">
    <div class="c-t">
      <template v-if="active == 1">
        <clockRecords v-if="!punchSetting"></clockRecords>
        <AdminClock v-else></AdminClock>
      </template>
      <punchClock v-else-if="active == 0"></punchClock>
      <template v-if="active == 2">
        <department v-if="punchSettings"></department>
      </template>
    </div>
    <div class="c-b">
      <van-tabbar v-model="active" @change="tabChange">
        <van-tabbar-item>
          <span>员工考勤</span>
          <template #icon="props">
            <img :src="props.active ? icon.active1 : icon.inactive1" />
          </template>
        </van-tabbar-item>

        <van-tabbar-item>
          <span>考勤统计</span>
          <template #icon="props">
            <img :src="props.active ? icon.active2 : icon.inactive2" />
          </template>
        </van-tabbar-item>

        <!-- 管理员 -->
        <template v-if="punchSettings">
          <van-tabbar-item>
            <span>打卡设置</span>
            <template #icon="props">
              <img :src="props.active ? icon.active3 : icon.inactive3" />
            </template>
          </van-tabbar-item>
        </template>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import clockRecords from './components/clockRecords'
import AdminClock from './components/adminClock'
import punchClock from './components/punchClock'
// import AttendanceSet from './attendanceSet'
import department from './components/department'
import active1 from '@/assets/images/lishui-elock-active.png'
import inactive1 from '@/assets/images/lishui-elock-inactive.png'
import active2 from '@/assets/images/lishui-record-active.png'
import inactive2 from '@/assets/images/lishui-record-inactive.png'
import active3 from '@/assets/images/setting-active.png'
import inactive3 from '@/assets/images/setting-inactive.png'
import {
  getLocalStorage,
  getQueryString,
  getUrlParam,
  setLocalStorage,
  removeLocalStorage
} from '@utils'
import { updateEmployee } from '@api/lishui/wx'
import {
  saveRecord,
  saveUVRecord,
  getEmployeeByCreditCodeAndOpenId
} from '@api/lishui'
export default {
  name: 'PunchClockRecords',
  props: {},
  data() {
    return {
      active: this.$store.state.clock.tabActiveIndex,
      icon: {
        active1,
        inactive1,
        active2,
        inactive2,
        active3,
        inactive3
      },
      userInfo: {},
      punchSetting: false,
      punchSettings: false,
      openId: getUrlParam('openId'),
      isOpenId: true,
      // 后端已经把信息放到cookie中，从cookie中拿
      creditCodeInCookies: Cookies.get('lishuiCreditCode'),
      entNameInCookies: Cookies.get('lishuiEntName'),
      mobileInCookies: Cookies.get('lishuiPh'),
      employeeStatisInCookies: Cookies.get('lishuiEmployeeStatis'),
      punchSettingInCookies: Cookies.get('lishuiPunchSetting'),
      staffTypeInCookies: Cookies.get('lishuiStaffType'),
      isAdminInCookies: Cookies.get('lishuiIsAdmin')

    }
  },
  created() {
    // 走了扫码的流程
    if (this.openId) {
      this.isOpenId = false
      removeLocalStorage('lishuiUserInfo')
      this.opendNew()
    } else {
      // 正常流程
      this.jurisdiction()
      if (this.getIsWxClient()) {
        // 正式环境
        if (process.env.NODE_ENV !== 'development') {
          const codeKey = getQueryString('code')
          if (codeKey) {
            this.wxInfo(codeKey)
          } else {
            this.wxGrant()
          }
        }
      }
    }
  },
  mounted() { },
  watch: {},
  beforeDestroy() {
    // sessionStorage.removeItem('lishuiTab')
  },
  methods: {
    opendNew() {
      const params = {
        creditCode: getUrlParam('creditCode'),
        openId: this.openId
      }
      getEmployeeByCreditCodeAndOpenId(params).then(res => {
        const { code, data } = res.data
        if (code === '0000') {
          console.log(data)
          setLocalStorage('lishuiUserInfo', JSON.stringify(data))
          console.log(getLocalStorage('lishuiUserInfo'))
          // location.reload()
          this.isOpenId = true
        } else {
          this.$router.push({ path: '/lishui/scanCode/errorForm' })
        }
      })
    },
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode || this.creditCodeInCookies,
        entName: this.userInfo.entName || this.entNameInCookies,
        mobile: this.userInfo.mobile || this.mobileInCookies
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      saveRecord(params).then(res => { })
      saveUVRecord(params).then(res => { })
    },
    // 判断微信环境
    getIsWxClient() {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      }
      return false
    },
    // 微信信息绑定
    wxInfo(codeKey) {
      let par = {
        code: codeKey,
        creditCode: this.userInfo.creditCode || this.creditCodeInCookies,
        mobile: this.userInfo.mobile || this.mobileInCookies
      }
      updateEmployee(par).then(res => {
        const { code, data, msg } = res.data
      })
    },
    wxGrant() {
      const appid = 'wxf52a05d6a1f8beb4'
      const url = window.location.href
      let urls = encodeURIComponent(url)
      window.location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        appid +
        '&redirect_uri=' +
        urls +
        '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
    },
    jurisdiction() {
      this.active = sessionStorage.getItem('lishuiTab')
        ? sessionStorage.getItem('lishuiTab') * 1
        : 0
      this.userInfo = getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
      if (this.userInfo.staffType === 1 || this.staffTypeInCookies == 1) {
        if (this.userInfo.employeeStatis === 1 || this.employeeStatisInCookies == 1) {
          this.punchSetting = true
        } else {
          this.punchSetting = false
        }
      } else {
        this.punchSetting = true
      }
      if (this.userInfo.staffType === 0 || this.userInfo.staffType === 2 || this.staffTypeInCookies == 0 || this.staffTypeInCookies == 2) {
        if (this.userInfo.punchSetting === 1 || this.punchSettingInCookies == 1) {
          this.punchSettings = true
        } else {
          this.punchSettings = false
        }
      } else {
        if (this.userInfo.isAdmin === 1 || this.isAdminInCookies == 1) {
          this.punchSettings = true
        } else {
          this.punchSettings = false
        }
      }
    },
    tabChange(index) {
      if (index === 1) {
        this.buriedPoint()
      }
      sessionStorage.setItem('lishuiTab', index)
    }
  },
  components: {
    clockRecords,
    punchClock,
    AdminClock,
    // AttendanceSet,
    department
  }
}
</script>

<style lang="scss" scoped>
#punchClockRecords {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .c-t {
    height: calc(100% - 60px);
  }
  .c-b {
    position: fixed;
    bottom: 0;
    height: 60px;
    width: 100%;
    z-index: 10;
    .van-tabbar {
      height: 60px;
    }
  }
}
</style>
